// SETUP VIDEO PLAYER ********************************            
$(window).on("load", function() {                                                                                                                                              

   const player = new Plyr('video', {captions: {active: true}});
   window.player = player;  

});








// PRODUCT CAROUSEL SECTION ********************************          
$(window).on("load", function()  {                                                                                     



   // globals ***
   var done = true,
       carContainerWidth,
       carProductWidth,
       carProductWrapperWidth,
       carDisplayFactor;



   // set product width & position *** 
   $(window).on("resize", function() {

	  if ($("#ProductsCarouselSection #Header .controls .control.mobile").css("display") === "inline-block") {
	  	carDisplayFactor = 0.8;   
	  } 
	  else {  
	  	carDisplayFactor = 0.4;     
	  }

	  carContainerWidth = $("#ProductsCarousel").width();
	  carProductWidth = (carContainerWidth * carDisplayFactor) - 22.5;      
	  carProductWrapperWidth = (carProductWidth * 4) + 90; 

      $("#ProductsCarouselInner .prod").css({"width": carProductWidth });
      $("#ProductsCarouselInner").css({"width": carProductWrapperWidth });

      for (i = 0; i < 4; i++) {
         $("#ProductsCarouselInner").children("a").eq(i).find(".prod").css({"left": (carProductWidth * i) + (30 * i) }); 
      }

   }).resize();  



   // controls *** 
   $("#ProductsCarouselSection .controls .control").click(function() {

   	   if (!($(this).hasClass("active")) && done) {

   	   	   doneUtil();

		   $("#ProductsCarouselSection .controls .control.active").removeClass("active");
		   $(this).addClass("active");
		   
		   var num = $(this).attr("data-num");  

		   $("#ProductsCarouselInner").css({"left": (num * (carProductWidth + 30)) * -1  }); 

       }

   });  
   


   // done util ***
   function doneUtil() {
	  done = false;
      setTimeout(function() { done = true; }, 1000);
   }



   // reset carousel *** 
   function resetCar() {
      $("#ProductsCarouselInner").css({"left":"0px"}); 
	  $("#ProductsCarouselSection .controls .control.active").removeClass("active");
	  $("#ProductsCarouselSection .controls .control.one").addClass("active"); 
   }



   // make carousel draggable ***
   /*
   let isDragStart = false, isDragging = false, prevPageX, prevScrollLeft, positionDiff;
   const carousel = document.getElementById("ProductsCarousel"), firstImg = document.getElementById("ProdCarImg1");  

   // The Element.scrollLeft property gets or sets the number of pixels that an element's content is scrolled from its left edge.
   // The Element.scrollWidth read-only property is a measurement of the width of an element's content, including content not visible on the screen
   // clientWidth property is zero for inline elements and elements with no CSS; otherwise, it's the inner width of an element in pixels. 

   function autoSlide() {
      
      // console.log(carousel.scrollLeft, carousel.scrollWidth, carousel.clientWidth);

   	  if (carousel.scrollLeft - (carousel.scrollWidth - carousel.clientWidth) > -1 || carousel.scrollLeft <= 0) return;

      positionDiff = Math.abs(positionDiff);
      let firstImgWidth = firstImg.clientWidth + 14;
      let valDifference = firstImgWidth - positionDiff;

      if(carousel.scrollLeft > prevScrollLeft) {
         return carousel.scrollLeft += positionDiff > firstImgWidth / 4 ? valDifference : -positionDiff;
      }

      carousel.scrollLeft -= positionDiff > firstImgWidth / 4 ? valDifference : -positionDiff;

   }

   function dragStart(e) {
      isDragStart = true;
      prevPageX = e.pageX || e.touches[0].pageX;
      prevScrollLeft = carousel.scrollLeft;
   }

   function dragging(e) {
      if(!isDragStart) return;
      isDragging = true; 
      carousel.classList.add("dragging"); 
      positionDiff = (e.pageX || e.touches[0].pageX) - prevPageX;
      carousel.scrollLeft = prevScrollLeft - positionDiff;
   }

   function dragStop() {
      isDragStart = false; 
      carousel.classList.remove("dragging"); 
      if(!isDragging) return;
      isDragging = false;
      autoSlide();
   }

   carousel.addEventListener("mousedown", dragStart);
   carousel.addEventListener("touchstart", dragStart);

   document.addEventListener("mousemove", dragging);
   carousel.addEventListener("touchmove", dragging);

   document.addEventListener("mouseup", dragStop);
   document.addEventListener("mouseleave", dragStop);
   carousel.addEventListener("touchend", dragStop);
   */



});








// FEATURED PRODUCT CAROUSEL SECTION ********************************          
$(window).on("load", function() {               



   
   // globals ***
   var done = true,
       thumbnailCarPosition = 0,
       featThumbDistance,
       featCarMaxIndex,
       currentFeaturedQty = 1;
 



   // init carousel ***
   for (i = 0; i < 4; i++) {  
      

      var img = $("#FeaturedHiddenCollectionData").children(".hiddenprod").eq(i).find(".img").html();
      var title = $("#FeaturedHiddenCollectionData").children(".hiddenprod").eq(i).find(".title").html(); 


      // set featured image & thumbnail
      $("#FeaturedSection #FeaturedImg .fimg.fi" + (i + 1)).css({"background-image":"url('" + img + "')"});
      $("#FeaturedSection #FeaturedImgControls .fcontrol.fc" + (i + 1)).css({"background-image":"url('" + img + "')"});   


      // set product title attribute for color navigation
      $("#FeaturedContent .btns.one").children("h5").eq(i).attr("data-activecolor", title); 


      // set active (first element) title, price and variants
      if (i === 0) {

         // title
         $("#FeaturedContent h1").html(title);

         // variants
         var variants = $("#FeaturedHiddenCollectionData").children(".hiddenprod").eq(i).find(".allvariants").children(".variant");
         for (n = 0; n < variants.length; n++) { 
            $("#FeaturedContent .btns.two .fqty.f" + (n + 1)).attr("data-variantid", variants.eq(n).attr("data-variantid")); 
            $("#FeaturedContent .btns.two .fqty.f" + (n + 1)).attr("data-variantprice", variants.eq(n).attr("data-variantprice"));         
            $("#FeaturedContent .btns.two .fqty.f" + (n + 1)).html(variants.eq(n).attr("data-varianttitle"));        
         }

         // price
         $("#FeaturedContent h3").html($("#FeaturedContent .btns.two .fqty.active").attr("data-variantprice") + " <span>Free Shipping & 30 Day Money Back Guarantee</span>"); 

      } 


   } 




   // display first image ***
   $("#FeaturedSection #FeaturedImg .fimg.fi1").css({"display":"block"});  




   // set variables on resize *** 
   $(window).on("resize", function() {

      var fcsWidth = $("#FeaturedSection").css("width"),
          fcsHeight = $("#FeaturedSection").css("height");   

      // desktop
      if (fcsWidth === "1250px" || fcsWidth === "1000px") {
        featThumbDistance = 110;
        featCarMaxIndex = 3;
      } 

      // smaller desktop - mobile
      if (fcsWidth === "821px" || fcsWidth === "500px" || fcsHeight === "990px") {         
        featThumbDistance = 90;
        featCarMaxIndex = 4; 
      } 

   }).resize();




   // control active thumbnail / featured image *** 
   $("#FeaturedImgControls .fcontrol").click(function() {

       if (!($(this).hasClass("active")) && done) { 

           doneUtil();

           // active thumbnail
           $("#FeaturedImgControls .fcontrol.active").removeClass("active");
           $(this).addClass("active"); 
           
           // save thumbnail num
           var activeCarNum = $(this).attr("data-num");  

           // hide current img
           $("#FeaturedImg .fimg.active").removeClass("active") 
           setTimeout(function() { $("#FeaturedImg .fimg.active").css({"display":"none"}); }, 510); 

           // display new img
           setTimeout(function() {
              $("#FeaturedImg .fimg.fi" + activeCarNum).css({"display":"block"});
              setTimeout(function() { $("#FeaturedImg .fimg.fi" + activeCarNum).addClass("active"); }, 20);
           }, 515);

       }

   });  




   // control thumbnail carousel ***
   $("#FeaturedImgControls .fcarrow").click(function() {

      // up
      if ($(this).hasClass("one") && (thumbnailCarPosition > 0)) {
         thumbnailCarPosition--; 
         moveThumbnailCarousel(); 
      }

      // down 
      if ($(this).hasClass("two") && (thumbnailCarPosition < featCarMaxIndex)) {
         thumbnailCarPosition++; 
         moveThumbnailCarousel();
      }

   });

   


   // move thumbnails *** 
   function moveThumbnailCarousel() {
      $("#FeaturedControlsCarouselInner").css({"top": ((thumbnailCarPosition * featThumbDistance) * -1)  });
   }




   // change active color & variants *** 
   $("#FeaturedContent .btns.one h5").click(function() {       

      if (!($(this).hasClass("active")) && done) {

         // get variant data
         var colorPosition = Number($(this).attr("data-activecolorimg"));
         var variants = $("#FeaturedHiddenCollectionData").children(".hiddenprod").eq(colorPosition - 1).find(".allvariants").children(".variant"); 

         for (n = 0; n < variants.length; n++) {  

            $("#FeaturedContent .btns.two .fqty.f" + (n + 1)).attr("data-variantid", variants.eq(n).attr("data-variantid")); 
            $("#FeaturedContent .btns.two .fqty.f" + (n + 1)).attr("data-variantprice", variants.eq(n).attr("data-variantprice"));         
            $("#FeaturedContent .btns.two .fqty.f" + (n + 1)).html(variants.eq(n).attr("data-varianttitle"));        

            /*
            $("#FeaturedContent .btns.two .innerbtns").append(
               "<h5 class='fqty v' data-variantid='" + variants.eq(n).attr("data-variantid") + "' data-variantprice='" + variants.eq(n).attr("data-variantprice") + "'>" + variants.eq(n).attr("data-varianttitle") + "</h5>"  
            );
            */  

         }

         // set new active color 
         $("#FeaturedContent .btns.one h5.active").removeClass("active");
         $(this).addClass("active");

         // set new header
         $("#FeaturedContent h1").html($(this).attr("data-activecolor"));

         // set price  
         $("#FeaturedContent h3").html($("#FeaturedContent .btns.two .fqty.active").attr("data-variantprice") + " <span>Free Shipping & 30 Day Money Back Guarantee</span>"); 

         // change featured image  
         $("#FeaturedControlsCarouselInner .fcontrol.fc" + $(this).attr("data-activecolorimg")).click(); 

      }

   });




   // change quantity (cart item and variant) ***  
   $(".btns .fqty").click(function() {

      var qtySpan = $("#FeaturedQuantity span.qty"); 

      if ($(this).hasClass("plus")) {
         currentFeaturedQty++;
         qtySpan.text(currentFeaturedQty);  
      }

      if ($(this).hasClass("minus") && currentFeaturedQty > 1) { 
         currentFeaturedQty--;
         qtySpan.text(currentFeaturedQty);   
      }

      if ($(this).hasClass("v")) {
         $(".btns.two .fqty.active").removeClass("active");
         $(this).addClass("active");  
         $("#FeaturedContent h3").html($(this).attr("data-variantprice") + " <span>Free Shipping & 30 Day Money Back Guarantee</span>");       
      }

   });




   // done util ***
   function doneUtil() {
      done = false;
      setTimeout(function() { done = true; }, 1100);
   }




});



 




// GALLERY SECTION ********************************  
$(window).on("load", function() {                       



   // globals ***
   var done = true,
       galleryImgWidth,
       galleryCarPosition = 0,
       galleryImgWidthFactor,
       galleryImgWidthOffset,
       galleryCarMaxIndex;



   // set carousel variables  &  convert to grid layout in mobile *** 
   $(window).on("resize", function() {  
      
      var gsHeight = $("#GallerySection").css("height");     

   	  // viewport > 1100
	  if (gsHeight === "400px" || gsHeight === "350px") {
	  	galleryImgWidthFactor = 0.25;
	  	galleryImgWidthOffset = 3;
	  	galleryCarMaxIndex = 2;
	  } 

	  // viewport < 1100 && > 850
	  if (gsHeight === "340px") {  
	  	galleryImgWidthFactor = 1 / 3; 
	  	galleryImgWidthOffset = 8 / 3;  
	  	galleryCarMaxIndex = 3; 
	  }   

   	  galleryImgWidth = ($("#GalleryCarousel").width() * galleryImgWidthFactor) - galleryImgWidthOffset;   

	  $("#GalleryCarouselInner .galleryimg").css({"width": galleryImgWidth });  

	  $("#GalleryCarouselInner").css({"width": (galleryImgWidth * 6) + 20 }); 

	  resetGalleryCar(); 

   }).resize();



   // controls *** 
   $("#GallerySection .gallerycontrol").click(function() { 

   	   if (done) { 

   	   	  doneUtil(); 

	   	  // left 
	      if ($(this).hasClass("left") && (galleryCarPosition > 0)) {
	      	 galleryCarPosition--; 
	      	 moveGalleryCarousel(); 
	      }

	      // right
	      if ($(this).hasClass("right") && (galleryCarPosition < galleryCarMaxIndex)) {
	      	 galleryCarPosition++; 
	      	 moveGalleryCarousel();
	      }

       }

   });  
   


   // move gallery ***
   function moveGalleryCarousel() {  
      $("#GalleryCarouselInner").css({"left": (((galleryImgWidth * galleryCarPosition) + (4 * galleryCarPosition)) * -1)  }); 
   }



   // reset carousel *** 
   function resetGalleryCar() {
      $("#GalleryCarouselInner").css({"left":"0px"});  
      galleryCarPosition = 0; 
   }



   // done util *** 
   function doneUtil() {
	  done = false;
      setTimeout(function() { done = true; }, 1000);
   }



}); 